// A lista de produtos da conta, com observações, combos e seleção.
import React from "react";
import { DadosDoPedido } from "../../../../store/Slices/orderSlice";
import * as Styles from "../../styles/PointOfSale.styles";
import { formatTime } from "../../../../dominio/dataEHora";

export const TabelaDeProdutos: React.FC<{
  component: any;
  componentProps: any;
  orderDataZustand: DadosDoPedido;
  setOrderDataZustand: (dados: any) => void;
  getComboProductInfo: (productUuid: any) => any;
}> = ({
  component,
  componentProps,
  orderDataZustand,
  setOrderDataZustand,
  getComboProductInfo,
}) => {
  return (
    <Styles.TableWrapper
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentStatus={String(componentProps.componentStatus)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.ProductTable
        componentBackgroundColor={String(
          componentProps.componentBackgroundColor
        )}
        componentColor={String(componentProps.componentColor)}
        componentFontSize={String(componentProps.componentFontSize)}
      >
        <Styles.ProductTableHeader
          componentColor={String(componentProps.componentColor)}
          componentBackgroundColor={String(
            componentProps.componentBackgroundColor
          )}
        >
          {componentProps.componentColumns?.map((column: any) =>
            column.columnStatus ? (
              column.columnInfo === "check" ? (
                <Styles.ProductTableHeaderCell
                  columnWidth={String(column.columnWidth)}
                  key={column.columnId}
                >
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      const updatedProducts =
                        orderDataZustand.products?.map(
                          (currentProduct) => {
                            return {
                              ...currentProduct,
                              productSelected: e.target.checked,
                            };
                          }
                        );
                      setOrderDataZustand({
                        ...orderDataZustand,
                        products: updatedProducts,
                      });
                    }}
                  />
                </Styles.ProductTableHeaderCell>
              ) : column.columnInfo === "expand" ? (
                <Styles.ProductTableHeaderCell
                  columnWidth={String(column.columnWidth)}
                  key={column.columnId}
                >
                  <Styles.ExpandIcon
                    onClick={() => {
                      const updatedProducts =
                        orderDataZustand.products?.map(
                          (currentProduct) => {
                            return {
                              ...currentProduct,
                              productExpanded:
                                !currentProduct.productExpanded,
                            };
                          }
                        );
                      setOrderDataZustand({
                        ...orderDataZustand,
                        products: updatedProducts,
                      });
                    }}
                  >
                    {orderDataZustand.products?.every(
                      (product) => product.productExpanded
                    )
                      ? "expand_less"
                      : "expand_more"}
                  </Styles.ExpandIcon>
                </Styles.ProductTableHeaderCell>
              ) : (
                <Styles.ProductTableHeaderCell
                  columnWidth={String(column.columnWidth)}
                  key={column.columnId}
                >
                  {column.columnLabel}
                </Styles.ProductTableHeaderCell>
              )
            ) : null
          )}
        </Styles.ProductTableHeader>
        <Styles.ProductTableBody
          componentColor={String(componentProps.componentColor)}
        >
          {orderDataZustand.products
            ?.sort((a, b) => {
              const aTime = a.productOrderedAt ? Date.parse(a.productOrderedAt) : 0;
              const bTime = b.productOrderedAt ? Date.parse(b.productOrderedAt) : 0;
              return aTime - bTime;
            })
            .map((product: any) => (
              <>
                <Styles.ProductTableRow
                  key={product.orderInfoId}
                  onClick={() => {
                    const updatedProducts =
                      orderDataZustand.products?.map(
                        (currentProduct) => {
                          if (
                            currentProduct.productOrderUuid ===
                            product.productOrderUuid
                          ) {
                            return {
                              ...currentProduct,
                              productSemiSelected:
                                !currentProduct.productSemiSelected,
                            };
                          }
                          return {
                            ...currentProduct,
                            productSemiSelected: false,
                          };
                        }
                      );
                    setOrderDataZustand({
                      ...orderDataZustand,
                      products: updatedProducts,
                    });
                  }}
                >
                  {componentProps.componentColumns?.map(
                    (column: any) =>
                      column.columnStatus ? (
                        column.columnInfo === "check" ? (
                          <Styles.ProductTableCell
                            key={column.columnId}
                            columnWidth={String(column.columnWidth)}
                            componentBackgroundColor={
                              product.productSelected
                                ? "black"
                                : product.productSemiSelected
                                  ? "black"
                                  : String(
                                    componentProps.componentBackgroundColor
                                  )
                            }
                          >
                            <input
                              type="checkbox"
                              checked={product.productSelected}
                              onChange={() => {
                                const updatedProducts =
                                  orderDataZustand.products?.map(
                                    (currentProduct) => {
                                      if (
                                        currentProduct.productOrderUuid ===
                                        product.productOrderUuid
                                      ) {
                                        return {
                                          ...currentProduct,
                                          productSelected:
                                            !currentProduct.productSelected,
                                        };
                                      }
                                      return {
                                        ...currentProduct,
                                        productSemiSelected:
                                          currentProduct.productSelected,
                                      };
                                    }
                                  );
                                setOrderDataZustand({
                                  ...orderDataZustand,
                                  products: updatedProducts,
                                });
                              }}
                            />
                          </Styles.ProductTableCell>
                        ) : column.columnInfo === "expand" ? (
                          <Styles.ProductTableCell
                            key={column.columnId}
                            columnWidth={String(column.columnWidth)}
                            componentBackgroundColor={
                              product.productSelected
                                ? "black"
                                : product.productSemiSelected
                                  ? "black"
                                  : String(
                                    componentProps.componentBackgroundColor
                                  )
                            }
                          >
                            <Styles.ExpandIcon
                              onClick={(event) => {
                                event.stopPropagation();
                                const updatedProducts =
                                  orderDataZustand.products?.map(
                                    (currentProduct) => {
                                      if (
                                        currentProduct.productOrderUuid ===
                                        product.productOrderUuid
                                      ) {
                                        return {
                                          ...currentProduct,
                                          productExpanded:
                                            !currentProduct.productExpanded,
                                        };
                                      }
                                      return currentProduct;
                                    }
                                  );
                                setOrderDataZustand({
                                  ...orderDataZustand,
                                  products: updatedProducts,
                                });
                              }}
                            >
                              {product.productExpanded
                                ? "expand_less"
                                : "expand_more"}
                            </Styles.ExpandIcon>
                          </Styles.ProductTableCell>
                        ) : (
                          <Styles.ProductTableCell
                            key={column.columnId}
                            columnWidth={String(column.columnWidth)}
                            componentBackgroundColor={
                              product.productSelected
                                ? "black"
                                : product.productSemiSelected
                                  ? "black"
                                  : String(
                                    componentProps.componentBackgroundColor
                                  )
                            }
                          >
                            {
                              column.columnInfo === "productOrderedAt" ? formatTime(String(product[
                                column.columnInfo as keyof typeof product
                              ])) :
                                product[
                                column.columnInfo as keyof typeof product
                                ]
                            }
                          </Styles.ProductTableCell>
                        )
                      ) : null
                  )}
                </Styles.ProductTableRow>
                {product.productExpanded &&
                  product.productObservations?.length > 0 && (
                    <>
                      <Styles.ProductTableRow>
                        <Styles.ProductTableCellObservation
                          colSpan={
                            componentProps.componentColumns?.length ||
                            1
                          }
                          textAlign="left"
                          selected={false}
                        >
                          Observações:
                        </Styles.ProductTableCellObservation>
                      </Styles.ProductTableRow>
                      {product.productObservations.map((observation: any) => (
                        <Styles.ProductTableRow>
                          <Styles.ProductTableCellObservation
                            colSpan={componentProps.componentColumns?.length || 1}
                            textAlign="center"
                            selected={observation.observationSelected}
                            onClick={() => {
                              const updatedProducts = orderDataZustand.products?.map((currentProduct) => {
                                if (currentProduct.productOrderUuid === product.productOrderUuid) {
                                  const updatedProductObservations = currentProduct.productObservations?.map((currentObservation) => {
                                    if (currentObservation.observationUuid === observation.observationUuid) {
                                      return {
                                        ...currentObservation,
                                        observationSelected: !currentObservation.observationSelected,
                                      };
                                    }
                                    return currentObservation;
                                  });
                                  return {
                                    ...currentProduct,
                                    productObservations: updatedProductObservations || currentProduct.productObservations,
                                  };
                                }
                                return currentProduct;
                              });
                              setOrderDataZustand({
                                ...orderDataZustand,
                                products: updatedProducts,
                              });
                            }}
                          >
                            {observation.observationPrice !== 0
                              ? `${observation.observationName} (valor adicional: ${observation.observationPrice.toFixed(2).replace(".", ",")})`
                              : observation.observationName}
                          </Styles.ProductTableCellObservation>
                        </Styles.ProductTableRow>
                      ))}
                    </>
                  )}
                {product.productExpanded && product.productComboInfo && (
                  <>
                    <Styles.ProductTableRow>
                      <Styles.ProductTableCellObservation
                        colSpan={componentProps.componentColumns?.length || 1}
                        textAlign="left"
                        selected={false}
                      >
                        Opções do Combo:
                      </Styles.ProductTableCellObservation>
                    </Styles.ProductTableRow>
                    {Object.entries(product.productComboInfo).map(([comboGroup, comboProductUuid]) => {
                      const comboProductInfo = getComboProductInfo(comboProductUuid);

                      return (
                        <Styles.ProductTableRow key={comboProductUuid as any}>
                          <Styles.ProductTableCellComboInfo
                            colSpan={componentProps.componentColumns?.length || 1}
                            textAlign="center"
                            selected={false}
                          >
                            {comboProductInfo
                              ? `${comboGroup}: ${comboProductInfo.productName} - Preço: ${Number(comboProductInfo.productPrice).toFixed(2).replace(".", ",")}`
                              : `${comboGroup}: Produto não encontrado`}
                          </Styles.ProductTableCellComboInfo>
                        </Styles.ProductTableRow>
                      );
                    })}
                  </>
                )}
              </>
            ))}
        </Styles.ProductTableBody>
      </Styles.ProductTable>
    </Styles.TableWrapper>
  );
};
